"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDashmixDropdown = exports.dashmixDropdownProps = void 0;
const composition_api_1 = require("@vue/composition-api");
const _abstract_1 = require("../../_abstract");
const _composables_1 = require("../../_composables");
const Button_1 = require("../Button");
const common_1 = require("../common");
const Dropdown_config_1 = require("./Dropdown.config");
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.dashmixDropdownProps = {
    ..._abstract_1.dropdownProps,
    triggerSize: _composables_1.getSizePropDefinition(),
    triggerTheme: {
        type: String,
        required: false,
        default: () => common_1.DashmixTheme.Primary
    },
    triggerVariant: {
        type: String,
        required: false,
        default: () => Button_1.DashmixButtonVariantMap.Default
    }
};
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.useDashmixDropdown = (props, ctx) => {
    const { align, position } = composition_api_1.toRefs(props);
    const { close, isOpen, open, toggle } = _abstract_1.useDropdown(props, ctx);
    const dropdownClass = _composables_1.useThemeClass(position, Dropdown_config_1.dashmixDropdownPositionClassRegistry);
    const dropdownMenuClass = _composables_1.useThemeClass(align, Dropdown_config_1.dashmixDropdownAlignClassRegistry);
    return { close, dropdownClass, dropdownMenuClass, isOpen, open, toggle };
};
//# sourceMappingURL=Dropdown.hooks.js.map